import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdCustomRolesDeleteCustomRoleIdCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/custom_roles/custom_role_management_data",
];
